var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Company } from 'packages/company/entities/Company';
import { Pagination } from 'packages/core/Pagination';
import { PaginatedQuery } from 'packages/utilities/PaginatedQuery';
import { EntityBuilder } from '@decahedron/entity';
import ENV from 'config/env';
var CompanyRepository = /** @class */ (function (_super) {
    __extends(CompanyRepository, _super);
    function CompanyRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'companies';
        _this.entity = Company;
        _this.baseUrl = ENV.JOBILLA_API_V2_URL;
        return _this;
    }
    CompanyRepository.prototype.search = function (name, pagination) {
        if (!pagination) {
            pagination = new Pagination();
        }
        var query = EntityBuilder.buildOne(PaginatedQuery, { pagination: pagination });
        query['filters[name]'] = name;
        query['sort[direction]'] = 'desc';
        query['sort[field]'] = 'created_at';
        return this.getPaginated("" + this.url, null, query.toJson());
    };
    CompanyRepository.prototype.privacyPolicyUrl = function (companyId) {
        return this.get("company/" + companyId + "/privacy-policy")
            .then(function (response) { return response.data.data.url; });
    };
    return CompanyRepository;
}(AbstractRepository));
export { CompanyRepository };
